(function () {
  'use strict';
  /*
   * Nuancier Talme.
   *
   * Colorise les selecteurs de teinte a partir du NOM de la valeur d'option.
   * Aucune donnee produit n'est modifiee : on lit le libelle affiche et on
   * pose une variable CSS --talme-swatch sur l'element. Les variantes, les
   * identifiants et le tunnel d'achat ne sont jamais touches.
   *
   * Pour ajouter une teinte, une seule ligne dans TEINTES ci-dessous.
   */

  /* Les teintes viennent des metaobjets Shopify (Contenu > Metaobjets > Color),
     exposes par snippets/talme-nuancier-donnees.liquid. Modifiez-les depuis
     l'admin : aucune valeur n'est figee ici.
     La table de repli ci-dessous ne sert que si le snippet est absent. */
  const REPLI = {
    blanc: '#FFFFFF',
    'blanc creme': '#F4EDDF',
    anthracite: '#3A3D42',
  };

  function chargerNuancier() {
    const balise = document.getElementById('TalmeNuancier');
    if (!balise) return null;
    try {
      const brut = JSON.parse(balise.textContent);
      const table = {};
      Object.keys(brut).forEach((nom) => {
        table[normaliser(nom)] = brut[nom];
      });
      return Object.keys(table).length ? table : null;
    } catch (e) {
      return null;
    }
  }

  let TEINTES = REPLI;

  /* "Ocre Foncé" -> "ocre fonce" */
  function normaliser(txt) {
    return (txt || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function couleurPour(libelle) {
    const cle = normaliser(libelle);
    if (TEINTES[cle]) return TEINTES[cle];
    /* correspondance partielle : "Blanc Crème 5L" -> blanc creme */
    const trouve = Object.keys(TEINTES)
      .sort((a, b) => b.length - a.length)
      .find((k) => cle.includes(k));
    return trouve ? TEINTES[trouve] : null;
  }

  /* le libelle visible d'un input radio / d'une option de select */
  function libelleDe(el) {
    if (el.tagName === 'OPTION') return el.textContent;
    const label = el.id ? document.querySelector(`label[for="${CSS.escape(el.id)}"]`) : null;
    return label ? label.textContent : el.value;
  }

  function estOptionCouleur(el) {
    const groupe = el.closest('.product-form__input, fieldset, .card__inner, card-variant-selects');
    if (!groupe) return false;
    const legende = groupe.querySelector('legend, .form__label');
    const nom = normaliser(legende ? legende.textContent : el.name || '');
    return nom.includes('couleur') || nom.includes('teinte') || nom.includes('color');
  }

  function appliquer(racine) {
    const cibles = (racine || document).querySelectorAll(
      'fieldset input[type="radio"], select option, card-variant-selects input[type="radio"],' +
      /* selecteurs maison : conditionnement produit et calculateur de pack */
      ' .talme-cond__color-pill, .talme-pack__color-pill'
    );
    cibles.forEach((el) => {
      if (el.dataset.talmeSwatch) return;

      const estPilule =
        el.classList &&
        (el.classList.contains('talme-cond__color-pill') ||
          el.classList.contains('talme-pack__color-pill'));
      if (el.tagName !== 'OPTION' && !estPilule && !estOptionCouleur(el)) return;

      const couleur = couleurPour(estPilule ? el.dataset.color || el.textContent : libelleDe(el));
      if (!couleur) return;

      el.dataset.talmeSwatch = couleur;

      let support;
      if (el.tagName === 'OPTION') support = el;
      else if (estPilule) support = el;
      else support = (el.id && document.querySelector(`label[for="${CSS.escape(el.id)}"]`)) || el;

      /* Les pastilles de variante de Shrine utilisent deja ::before en position
         absolue. On insere donc un vrai element plutot qu'un pseudo-element :
         aucun risque de collision, quel que soit le CSS du theme. */
      if (support.tagName === 'OPTION') {
        support.style.setProperty('--talme-swatch', couleur);
        support.classList.add('talme-has-swatch');
        return;
      }

      if (support.querySelector('.talme-chip')) return;

      /* La goutte de teinte prime sur la puce carree.
         Les deux selecteurs maison rendent desormais une goutte en Liquid, a
         partir des memes metaobjets couleur : y poser une puce afficherait
         deux pastilles cote a cote pour la meme teinte, ce qui etait le cas
         jusqu'ici. La puce reste le repli des pilules dont le nom ne
         correspond a aucun metaobjet, et de tous les selecteurs natifs du
         theme, qui n'ont pas de goutte. */
      if (support.querySelector('.talme-cond__color-goutte, .talme-pack__color-goutte')) return;
      const chip = document.createElement('span');
      chip.className = 'talme-chip';
      chip.setAttribute('aria-hidden', 'true');
      chip.style.setProperty('--talme-swatch', couleur);
      /* teinte tres claire : contour renforce pour rester visible sur blanc */
      if (/^#(f|e)/i.test(couleur)) chip.classList.add('talme-chip--clair');
      support.insertBefore(chip, support.firstChild);
      support.classList.add('talme-has-swatch');
    });
  }

  const demarrer = () => {
    TEINTES = chargerNuancier() || REPLI;
    appliquer(document);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* la page produit reconstruit ses selecteurs a chaque changement de variante */
  document.addEventListener('shopify:section:load', (e) => appliquer(e.target));
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) appliquer(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
